import { FC, lazy, Suspense } from 'react';
import { InfoProps } from 'shared/interfaces/ILoadingData';
import { IUpload } from 'shared/interfaces/IUpload';

const ListVariantItem = lazy(() => import('./ListVariantItem/ListVariantItem'));
const GridVariantItem = lazy(() => import('./GridVariantItem/GridVariantItem'));

export type InfoItemProps = {
  info: InfoProps[];
  attached_media?: IUpload[];
  onEdit?: VoidFunction;
  onDelete?: VoidFunction;
  onView?: VoidFunction;
  isSaving?: boolean;
  isEditing?: boolean;
  isDeleting?: boolean;
  variant?: 'list' | 'grid';
};

// Main InfoItem component
const InfoItem: FC<InfoItemProps> = ({ variant = 'list', ...props }) => {
  return (
    <Suspense fallback="">
      {variant === 'list' ? <ListVariantItem {...props} /> : <GridVariantItem {...props} />}
    </Suspense>
  );
};

export default InfoItem;
